module.exports = __webpack_public_path__ + "media/images/official/company_ceo-0b2d7ebfd6fb61d5fae6802e581471c9.jpg";